import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const { instance, accounts } = useMsal();
  const location = useLocation();
  
  const username = accounts.length > 0 ? accounts[0].name : '';
  
  const handleRefresh = () => {
    // You can emit an event or use a callback for refreshing data
    window.location.reload();
  };
  
  const handleLogout = () => {
    // First, clear all storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Force removal of MSAL accounts and tokens
    if (instance && accounts.length > 0) {
      try {
        // Try to remove the account silently in the background
        instance.setActiveAccount(null);
        
        // Let MSAL know we're logging out, but don't wait for it
        setTimeout(() => {
          instance.logout().catch(e => console.log('Silent logout cleanup:', e));
        }, 100);
      } catch (error) {
        console.error('Error during logout cleanup:', error);
      }
    }
    
    // Navigate immediately to the onboarding page
    window.location.href = '/'; // Direct browser navigation is more reliable
  };
  
  // Helper to determine if a path is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-blue-600 text-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center mb-2 md:mb-0">
          <h1 className="text-2xl font-bold">AWS EC2 Controller</h1>
          
          <nav className="ml-8 hidden md:flex space-x-4">
            <Link 
              to="/dashboard" 
              className={`px-3 py-1 rounded ${isActive('/dashboard') ? 'bg-blue-700' : 'hover:bg-blue-500'}`}
            >
              Dashboard
            </Link>
            <Link 
              to="/dashboard/sagemaker" 
              className={`px-3 py-1 rounded ${isActive('/dashboard/sagemaker') ? 'bg-blue-700' : 'hover:bg-blue-500'}`}
            >
              SageMaker
            </Link>
          </nav>
        </div>
        
        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
          {username && (
            <span className="text-sm hidden md:inline">
              Welcome, {username}
            </span>
          )}
          
          <div className="flex space-x-2">
            <button 
              onClick={handleRefresh}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
            >
              Refresh
            </button>
            
            <button 
              onClick={handleLogout}
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Navigation */}
      <div className="md:hidden bg-blue-700 py-2">
        <div className="container mx-auto px-4 flex justify-around">
          <Link 
            to="/dashboard" 
            className={`px-3 py-1 rounded ${isActive('/dashboard') ? 'bg-blue-800' : ''} text-center flex-1 mx-1`}
          >
            Dashboard
          </Link>
          <Link 
            to="/dashboard/sagemaker" 
            className={`px-3 py-1 rounded ${isActive('/dashboard/sagemaker') ? 'bg-blue-800' : ''} text-center flex-1 mx-1`}
          >
            SageMaker
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 